<template>
	<div class="centerWidth">
		<div class="gaokao">
			<!-- <div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>学生学情档案</span>
			</div> -->
			<section class="gaokao-content">
				<div class="my-title">学生学情档案</div>
				<article class="fenNum_head flex zhong center xieqDiv">
					<p class="on">
						<i></i>
						<span>基本信息</span>
					</p>
					<p>
						<i></i>
						<span>成绩信息</span>
					</p>
					<p>
						<i></i>
						<span>综合信息</span>
					</p>
					<p>
						<i></i>
						<span>偏爱方向</span>
					</p>
				</article>
				<article class="file-from">
					<div class="from-c01 zhong">
						<p class="from-txt">姓名：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入姓名" v-model="Name" /></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">证件号码：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入证件号码" v-model="Certificates" /></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">手机号码：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入手机号码" v-model="Phone" /></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">考生性别：</p>
						<div class="from-input zhong">
							<p class="from-rad">
								<input type="radio" :checked="Gender == '男'" @click="SetGender('男')" name="sex" />
								<span>男</span>
							</p>
							<p class="from-rad">
								<input type="radio" :checked="Gender == '女'" @click="SetGender('女')" name="sex" />
								<span>女</span>
							</p>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">出生日期：</p>
						<div class="from-input zhong">
							<el-date-picker v-model="BirthDate" type="date" class="from-pick" placeholder="请选择日期" value-format="yyyy-MM-dd"></el-date-picker>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">民族：</p>
						<div class="from-input zhong">
							<el-select v-model="Nation" class="from-pick" placeholder="请选择">
								<template v-if="NationList.length > 0">
									<el-option v-for="item in NationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
								</template>
							</el-select>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">政治面貌：</p>
						<div class="from-input zhong">
							<el-select v-model="PoliticalOutlook" class="from-pick" placeholder="请选择">
								<el-option v-for="item in PoliticalOutlookList" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
							</el-select>
						</div>
					</div>
					<div class="from-c01 basel">
						<p class="from-txt">裸眼视力(左/右)：</p>
						<div class="from-input flex-fw">
							<div class="flex zhong">
								<input class="ipt-bg" placeholder="请输入裸眼视力左" v-model="VisionLeft" />
								<span class="ipt-txt">/</span>
								<input class="ipt-bg" placeholder="请输入裸眼视力右" v-model="VisionRight" />
								<span class="ipt-txt">(视力标准为0.1-1.5(或4.0-5.2))</span>
							</div>
							<p class="from-p">请查看学校招生简章，如果报考专业对视力、是否色盲、身高、体重有要求，则必须填写</p>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">是否色盲：</p>
						<div class="from-input zhong">
							<el-select v-model="ColorBlindness" class="from-pick" placeholder="请选择">
								<el-option key="非色盲" label="非色盲" value="非色盲"></el-option>
								<el-option key="色盲" label="色盲" value="色盲"></el-option>
								<el-option key="色弱" label="色弱" value="色弱"></el-option>
							</el-select>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">身高(cm)：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入身高" v-model="Height" /></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">体重(kg)：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入体重" v-model="Weight" /></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">是否为左撇子：</p>
						<div class="from-input zhong">
							<p class="from-rad">
								<input type="radio" :checked="IsLeftHanded" @click="SetIsLeftHanded(1)" name="hand" />
								<span>是</span>
							</p>
							<p class="from-rad">
								<input type="radio" :checked="!IsLeftHanded" @click="SetIsLeftHanded(0)" name="hand" />
								<span>否</span>
							</p>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">户籍所在地：</p>
						<div class="from-input zhong"><area-select type="text" :level="2" v-model="HouseholdList" :data="pcaa"></area-select></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">高考报名所在地：</p>
						<div class="from-input zhong"><area-select type="text" :level="2" v-model="LocationList" :data="pcaa"></area-select></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">高考报名号：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入高考报名号" v-model="CollegeNuber" /></div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">考生类型：</p>
						<div class="from-input">
							<el-select v-model="Candidates" class="from-pick" placeholder="请选择">
								<el-option v-for="item in CandidatesList" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
							</el-select>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">外语语种：</p>
						<div class="from-input">
							<el-select v-model="languages" class="from-pick" placeholder="请选择">
								<el-option v-for="item in languagesList" :key="item.Name" :label="item.Name" :value="item.Name"></el-option>
							</el-select>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">学科类型：</p>
						<div class="from-input">
							<el-select v-model="Subject" class="from-pick" placeholder="请选择">
								<el-option key="文史" label="文史" value="文史"></el-option>
								<el-option key="理工" label="理工" value="理工"></el-option>
								<el-option key="综合改革" label="综合改革" value="综合改革"></el-option>
							</el-select>
						</div>
					</div>
					<div class="from-c01 zhong">
						<p class="from-txt">邮政编码：</p>
						<div class="from-input"><input class="ipt-bg" placeholder="请输入邮政编码" v-model="PostalCode" /></div>
					</div>
					<div class="from-c01 start">
						<p class="from-txt">家庭信息：</p>
						<div class="from-info">
							<div class="info-c01">
								<p class="info-tit">父亲信息</p>
								<ul class="info-list">
									<li>
										<p>姓名：</p>
										<input class="info-ipt" placeholder="请输入姓名" v-model="FatherName" />
									</li>
									<li>
										<p>手机号码：</p>
										<input class="info-ipt" placeholder="请输入手机号码" v-model="FatherPhone" />
									</li>
									<li>
										<p>文化程度：</p>
										<el-select v-model="FatherEducation" class="info-pick" placeholder="请选择">
											<el-option key="博士" label="博士" value="博士"></el-option>
											<el-option key="硕士" label="硕士" value="硕士"></el-option>
											<el-option key="本科" label="本科" value="本科"></el-option>
											<el-option key="专科" label="专科" value="专科"></el-option>
											<el-option key="高中及以下" label="高中及以下" value="高中及以下"></el-option>
										</el-select>
									</li>
									<li>
										<p>职业：</p>
										<input class="info-ipt" placeholder="请输入职业" v-model="FatherOccupation" />
									</li>
									<li>
										<p>工作单位：</p>
										<input class="info-ipt" placeholder="请输入工作单位" v-model="FatherWorkUnit" />
									</li>
									<li>
										<p>职务：</p>
										<input class="info-ipt" placeholder="请输入职务" v-model="FatherDuties" />
									</li>
								</ul>
							</div>
							<div class="info-c01">
								<p class="info-tit">母亲信息</p>
								<ul class="info-list">
									<li>
										<p>姓名：</p>
										<input class="info-ipt" placeholder="请输入姓名" v-model="MotherName" />
									</li>
									<li>
										<p>手机号码：</p>
										<input class="info-ipt" placeholder="请输入手机号码" v-model="MotherPhone" />
									</li>
									<li>
										<p>文化程度：</p>
										<el-select v-model="MotherEducation" class="info-pick" placeholder="请选择">
											<el-option key="博士" label="博士" value="博士"></el-option>
											<el-option key="硕士" label="硕士" value="硕士"></el-option>
											<el-option key="本科" label="本科" value="本科"></el-option>
											<el-option key="专科" label="专科" value="专科"></el-option>
											<el-option key="高中及以下" label="高中及以下" value="高中及以下"></el-option>
										</el-select>
									</li>
									<li>
										<p>职业：</p>
										<input class="info-ipt" placeholder="请输入职业" v-model="MotherOccupation" />
									</li>
									<li>
										<p>工作单位：</p>
										<input class="info-ipt" placeholder="请输入工作单位" v-model="MotherWorkUnit" />
									</li>
									<li>
										<p>职务：</p>
										<input class="info-ipt" placeholder="请输入职务" v-model="MotherDuties" />
									</li>
								</ul>
							</div>
						</div>
					</div>
				</article>
				<button class="gaokao-btn" @click="goGrade()">下一步</button>
			</section>
		</div>
	</div>
</template>

<script>
import 'vue-area-linkage/dist/index.css';
import { pca, pcaa } from 'area-data';
export default {
	data() {
		return {
			sid: 0,
			pca: pca,
			pcaa: pcaa,
			Name: '',
			Certificates: '',
			Phone: '',
			Gender: '男',
			BirthDate: '',
			Nation: '',
			NationList: [],
			PoliticalOutlook: '',
			PoliticalOutlookList: [],
			VisionLeft: '',
			VisionRight: '',
			ColorBlindness: '',
			Height: '',
			Weight: '',
			IsLeftHanded: false,
			Household: '',
			Location: '',
			HouseholdList: [],
			LocationList: [],
			CollegeNuber: '',
			Candidates: '',
			CandidatesList: [],
			languages: '',
			languagesList: [],
			Subject: '',
			PostalCode: '',
			FatherName: '',
			FatherPhone: '',
			FatherEducation: '',
			FatherOccupation: '',
			FatherWorkUnit: '',
			FatherDuties: '',
			MotherName: '',
			MotherPhone: '',
			MotherEducation: '',
			MotherOccupation: '',
			MotherWorkUnit: '',
			MotherDuties: '',
			IsCke: true
		};
	},
	// 加载
	created() {
		var that = this;
		var sid = that.$route.query.sid;
		if (sid > 0) {
			console.log('有ID', sid);
			that.GetStudentsAcademicRecordsById(sid);
			that.sid = sid;
		}
		that.GetStudentsInfroTypeList(1);
		that.GetStudentsInfroTypeList(2);
		that.GetStudentsInfroTypeList(3);
		that.GetStudentsInfroTypeList(4);
	},
	methods: {
		GetStudentsInfroTypeList(typeid) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetStudentsInfroTypeList?typeid=' + typeid,
				'GET',
				{},
				function(res) {
					console.log('获取', res);
					if (res.flag) {
						if (typeid === 1) {
							that.NationList = res.list;
						}
						if (typeid === 2) {
							that.PoliticalOutlookList = res.list;
						}
						if (typeid === 3) {
							that.CandidatesList = res.list;
						}
						if (typeid === 4) {
							that.languagesList = res.list;
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		GetStudentsAcademicRecordsById(sid) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetStudentsAcademicRecordsById?id=' + sid,
				'GET',
				{},
				function(res) {
					console.log('获取详情', res);
					if (res.flag) {
						var entity = res.entity;
						that.Name = entity.Name;
						that.Certificates = entity.Certificates;
						that.Phone = entity.Phone;
						that.Gender = entity.Gender;
						that.BirthDate = entity.BirthDate;
						that.Nation = entity.Nation;

						that.PoliticalOutlook = entity.PoliticalOutlook;

						that.VisionLeft = entity.VisionLeft;
						that.VisionRight = entity.VisionRight;
						that.ColorBlindness = entity.ColorBlindness;
						that.Height = entity.Height;
						that.Weight = entity.Weight;
						that.IsLeftHanded = entity.IsLeftHanded;
						that.Household = entity.Household;
						that.Location = entity.Location;
						that.HouseholdList = entity.HouseholdList;
						that.LocationList = entity.LocationList;
						that.CollegeNuber = entity.CollegeNuber;
						that.Candidates = entity.Candidates;

						that.languages = entity.languages;

						that.Subject = entity.Subject;
						that.PostalCode = entity.PostalCode;
						that.FatherName = entity.FatherName;
						that.FatherPhone = entity.FatherPhone;
						that.FatherEducation = entity.FatherEducation;
						that.FatherOccupation = entity.FatherOccupation;
						that.FatherWorkUnit = entity.FatherWorkUnit;
						that.FatherDuties = entity.FatherDuties;
						that.MotherName = entity.MotherName;
						that.MotherPhone = entity.MotherPhone;
						that.MotherEducation = entity.MotherEducation;
						that.MotherOccupation = entity.MotherOccupation;
						that.MotherWorkUnit = entity.MotherWorkUnit;
						that.MotherDuties = entity.MotherDuties;

						that.HouseholdList = that.Household.split('-');

						that.LocationList = that.Location.split('-');
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		SetGender(val) {
			this.Gender = val;
		},
		SetIsLeftHanded(ixd) {
			this.IsLeftHanded = ixd === 1;
		},
		// 测试
		goGrade() {
			var that = this;
			if (!that.IsCke) {
				return;
			}

			// if (that.Name.length === 0) {
			// 	that.$util.showError('请输入姓名');
			// 	return false;
			// }
			// if (that.Certificates.length === 0) {
			// 	that.$util.showError('请输入证件号码');
			// 	return false;
			// }
			// if (that.Phone.length === 0) {
			// 	that.$util.showError('请输入手机号码');
			// 	return false;
			// }
			// if (that.BirthDate.length === 0) {
			// 	that.$util.showError('请选择出生日期');
			// 	return false;
			// }
			// if (that.Nation.length === 0) {
			// 	that.$util.showError('请选择民族');
			// 	return false;
			// }
			// if (that.PoliticalOutlook.length === 0) {
			// 	that.$util.showError('请选择政治面貌');
			// 	return false;
			// }
			// if (that.VisionLeft.length === 0) {
			// 	that.$util.showError('请输入视力');
			// 	return false;
			// }
			// if (that.VisionRight.length === 0) {
			// 	that.$util.showError('请输入视力');
			// 	return false;
			// }

			// if (that.ColorBlindness.length === 0) {
			// 	that.$util.showError('请选择是否色盲');
			// 	return false;
			// }

			// if (that.Height.length === 0) {
			// 	that.$util.showError('请输入身高');
			// 	return false;
			// }
			// if (that.Weight.length === 0) {
			// 	that.$util.showError('请输入体重');
			// 	return false;
			// }
			if (that.HouseholdList.length > 0) {
				that.Household = that.HouseholdList.join('-');
			}
			if (that.LocationList.length > 0) {
				that.Location = that.LocationList.join('-');
			}

			// if (that.Household.length === 0) {
			// 	that.$util.showError('请选择户籍');
			// 	return false;
			// }
			// if (that.Location.length === 0) {
			// 	that.$util.showError('请选择所在地');
			// 	return false;
			// }

			// if (that.CollegeNuber.length === 0) {
			// 	that.$util.showError('请输入高考报名号');
			// 	return false;
			// }
			// if (that.Candidates.length === 0) {
			// 	that.$util.showError('请选择考生类型');
			// 	return false;
			// }
			// if (that.languages.length === 0) {
			// 	that.$util.showError('请选择外语语种');
			// 	return false;
			// }
			// if (that.Subject.length === 0) {
			// 	that.$util.showError('请选择学科类型');
			// 	return false;
			// }
			// if (that.PostalCode.length === 0) {
			// 	that.$util.showError('请输入邮政编码');
			// 	return false;
			// }
			// if (that.FatherName.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.FatherPhone.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.FatherEducation.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.FatherOccupation.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }

			// if (that.FatherWorkUnit.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.FatherDuties.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.MotherName.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.MotherPhone.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.MotherEducation.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.MotherOccupation.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.MotherWorkUnit.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }
			// if (that.MotherDuties.length === 0) {
			// 	that.$util.showError('请完善家庭信息');
			// 	return false;
			// }

			that.IsCke = false;

			var data = {
				Id: that.sid,
				Name: that.Name,
				Certificates: that.Certificates,
				Phone: that.Phone,
				Gender: that.Gender,
				BirthDate: that.BirthDate,
				Nation: that.Nation,
				PoliticalOutlook: that.PoliticalOutlook,
				VisionLeft: that.VisionLeft,
				VisionRight: that.VisionRight,
				ColorBlindness: that.ColorBlindness,
				Height: that.Height,
				Weight: that.Weight,
				IsLeftHanded: that.IsLeftHanded,
				Household: that.Household,
				Location: that.Location,
				CollegeNuber: that.CollegeNuber,
				Candidates: that.Candidates,
				languages: that.languages,
				Subject: that.Subject,
				PostalCode: that.PostalCode,
				FatherName: that.FatherName,
				FatherPhone: that.FatherPhone,
				FatherEducation: that.FatherEducation,
				FatherOccupation: that.FatherOccupation,
				FatherWorkUnit: that.FatherWorkUnit,
				FatherDuties: that.FatherDuties,
				MotherName: that.MotherName,
				MotherPhone: that.MotherPhone,
				MotherEducation: that.MotherEducation,
				MotherOccupation: that.MotherOccupation,
				MotherWorkUnit: that.MotherWorkUnit,
				MotherDuties: that.MotherDuties
			};
			console.log(data);

			that.$api.HtppRequest(
				'SystemData/AddStudentsAcademicRecords',
				'POST',
				data,
				function(res) {
					console.log('添加', res);

					if (res.flag) {
						that.$router.push({ path: '/grade', query: { sid: res.SId } });
					}
					that.IsCke = true;
				},
				function(err) {
					console.log(err);
					that.IsCke = true;
				}
			);
		}
	}
};
</script>

<style scoped>
.gaokao {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
.fenNum_head {
	margin-top: 20px;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
/* file-from */
.file-from {
	width: 100%;
	height: auto;
	overflow: hidden;
	margin-top: 35px;
}
.from-c01 {
	width: 100%;
	display: flex;
	margin-bottom: 10px;
}
.from-txt {
	width: 20%;
	text-align: right;
	font-size: 15px;
	color: #333;
}
.from-input {
	width: 80%;
	display: flex;
}
.ipt-bg {
	width: 300px;
	height: 40px;
	line-height: 38px;
	border: 1px solid #eee;
	font-size: 15px;
	color: #333;
	padding: 0 10px;
	border-radius: 4px;
}
.ipt-bg::-webkit-input-placeholder {
	color: #999;
}
.ipt-bg:-moz-placeholder {
	color: #999;
}
.ipt-bg:-ms-input-placeholder {
	color: #999;
}
.from-rad {
	display: flex;
	align-items: center;
	width: 150px;
	padding: 10px 0;
}
.from-rad span {
	font-size: 15px;
	color: #999;
	padding-left: 10px;
}
.from-pick {
	width: 300px;
}
.ipt-txt {
	font-size: 15px;
	color: #999;
	padding: 0 20px;
}
.from-p {
	margin-top: 10px;
	padding: 7px 15px;
	font-size: 14px;
	color: #999;
	background-color: #f2f2f2;
}
.from-info {
	width: 80%;
	height: auto;
	overflow: hidden;
	border: 1px solid #eee;
}
.info-c01 {
	width: 100%;
	border-bottom: 1px solid #eee;
	height: auto;
	padding-bottom: 10px;
}
.info-c01:last-child {
	border-bottom: 0px;
}
.info-tit {
	text-align: center;
	font-size: 16px;
	color: #333;
	padding: 30px 0;
}
.info-list {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}
.info-list li {
	width: calc(100% / 3);
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.info-list li p {
	font-size: 15px;
	color: #333;
	width: 25%;
	text-align: right;
}
.info-list li input {
	width: 150px;
	height: 40px;
	border: 1px solid #eee;
	line-height: 40px;
	border-radius: 4px;
	font-size: 15px;
	color: #333;
	padding: 0 10px;
}
.info-list li input::-webkit-input-placeholder {
	color: #999;
}
.info-list li input:-moz-placeholder {
	color: #999;
}
.info-list li input:-ms-input-placeholder {
	color: #999;
}
.info-pick {
	width: 150px;
}
.gaokao-btn {
	width: 200px;
	height: 40px;
	background-color: #333;
	border-radius: 6px;
	font-size: 16px;
	color: #fff;
	line-height: 40px;
	margin: 50px auto;
	display: block;
}
</style>
